import React, { useState } from 'react';
import DataTable from './DataTable';

const CollegeInfoTabs = ({ medicalColleges, studyAbroad }) => {
  const [activeTab, setActiveTab] = useState('mbbs-up');
  const [locationFilter, setLocationFilter] = useState('');
  const [feeFilter, setFeeFilter] = useState('');
  const [seatsFilter, setSeatsFilter] = useState('');

  const tabs = [
    { id: 'mbbs-up', label: 'MBBS in UP (Fees)' },
    { id: 'bams-up-private', label: 'BAMS in UP (Private)', anchor: 'bams-colleges' },
    { id: 'bams-up-govt', label: 'BAMS in UP (Govt)', anchor: 'bams-colleges' },
    { id: 'bams-uttarakhand', label: 'BAMS in Uttarakhand', anchor: 'bams-colleges' },
    { id: 'mbbs-nepal', label: 'MBBS in Nepal' },
  ];

  const mbbsColumns = [
    {
      header: 'College Name',
      accessor: 'name',
      render: (value) => (
        <div className="flex items-center gap-2">
          <img src="/assets/CollegeIcon.svg" alt="" className="h-5 w-5 shrink-0" />
          <span>{value}</span>
        </div>
      )
    },
    { header: 'Location', accessor: 'location.city' },
    { header: 'First Year Fee (₹)', accessor: 'fees.firstYearTotalNonAC', format: 'currency' },
    { header: 'Total Package (₹)', accessor: 'fees.totalPackageNonAC', format: 'currency' },
  ];

  const bamsColumns = [
    {
      header: 'College Name',
      accessor: 'nameEnglish',
      render: (value) => (
        <div className="flex items-center gap-2">
          <img src="/assets/CollegeIcon.svg" alt="" className="h-5 w-5 shrink-0" />
          <span>{value}</span>
        </div>
      )
    },
    { header: 'Location', accessor: 'location.city' },
    { header: 'District', accessor: 'location.district' },
    { header: 'Seats', accessor: 'seatIntake' },
  ];

  const uttarakhandColumns = [
    {
      header: 'College Name',
      accessor: 'name',
      render: (value) => (
        <div className="flex items-center gap-2">
          <img src="/assets/CollegeIcon.svg" alt="" className="h-5 w-5 shrink-0" />
          <span>{value}</span>
        </div>
      )
    },
    { header: 'Location', accessor: 'location.city' },
    { header: 'Address', accessor: 'location.address' },
  ];

  const nepalColumns = [
    {
      header: 'College Name',
      accessor: 'name',
      render: (value) => (
        <div className="flex items-center gap-2">
          <img src="/assets/NepalFlag.svg" alt="Nepal" className="h-5 w-5 shrink-0" />
          <span>{value}</span>
        </div>
      )
    },
  ];

  const getTableData = () => {
    let data = [], columns = [], title = '', locations = [];
    let hasFees = false, hasSeats = false, feeRanges = [], seatRanges = [];

    switch (activeTab) {
      case 'mbbs-up':
        data = medicalColleges?.uttarPradesh?.mbbs?.privateCollegesFeeStructure_2024 || [];
        columns = mbbsColumns;
        title = 'MBBS in Uttar Pradesh — Private Colleges Fee Structure 2024';
        locations = [...new Set(data.map(item => item.location?.city).filter(Boolean))];
        hasFees = true;
        feeRanges = [
          { label: 'Under ₹18 Lakhs', value: 'under-18', min: 0, max: 1800000 },
          { label: '₹18 – 20 Lakhs', value: '18-20', min: 1800000, max: 2000000 },
          { label: 'Above ₹20 Lakhs', value: 'above-20', min: 2000000, max: Infinity },
        ];
        break;
      case 'bams-up-private':
        data = medicalColleges?.uttarPradesh?.bams?.privateColleges || [];
        columns = bamsColumns;
        title = 'BAMS in Uttar Pradesh — Private Colleges';
        locations = [...new Set(data.map(item => item.location?.city).filter(Boolean))];
        hasSeats = true;
        seatRanges = [
          { label: '60 Seats or Less', value: 'under-60', min: 0, max: 60 },
          { label: '61 – 99 Seats', value: '61-99', min: 61, max: 99 },
          { label: '100 Seats or More', value: '100+', min: 100, max: Infinity },
        ];
        break;
      case 'bams-up-govt':
        data = medicalColleges?.uttarPradesh?.bams?.governmentColleges || [];
        columns = bamsColumns;
        title = 'BAMS in Uttar Pradesh — Government Colleges';
        locations = [...new Set(data.map(item => item.location?.city).filter(Boolean))];
        hasSeats = true;
        seatRanges = [
          { label: 'Under 40 Seats', value: 'under-40', min: 0, max: 40 },
          { label: '40 – 50 Seats', value: '40-50', min: 40, max: 50 },
          { label: 'Above 50 Seats', value: 'above-50', min: 50, max: Infinity },
        ];
        break;
      case 'bams-uttarakhand':
        data = medicalColleges?.uttarakhand?.bams?.privateColleges || [];
        columns = uttarakhandColumns;
        title = 'BAMS in Uttarakhand — Private Colleges';
        locations = [...new Set(data.map(item => item.location?.city).filter(Boolean))];
        break;
      case 'mbbs-nepal':
        data = studyAbroad?.mbbsInNepal?.featuredColleges?.map(college => ({ name: college })) || [];
        columns = nepalColumns;
        title = 'MBBS in Nepal — Kathmandu University Affiliated Colleges';
        break;
      default:
        break;
    }

    if (locationFilter) data = data.filter(item => item.location?.city === locationFilter);
    if (feeFilter && hasFees) {
      const range = feeRanges.find(r => r.value === feeFilter);
      if (range) data = data.filter(item => {
        const fee = item.fees?.firstYearTotalNonAC;
        return fee >= range.min && fee <= range.max;
      });
    }
    if (seatsFilter && hasSeats) {
      const range = seatRanges.find(r => r.value === seatsFilter);
      if (range) data = data.filter(item => item.seatIntake >= range.min && item.seatIntake <= range.max);
    }

    return { data, columns, title, locations, hasFees, hasSeats, feeRanges, seatRanges };
  };

  const tableInfo = getTableData();

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setLocationFilter('');
    setFeeFilter('');
    setSeatsFilter('');
  };

  const selectClass = "w-full md:w-56 px-3 py-2 border border-slate-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500";

  return (
    <section id="colleges" className="py-16 md:py-24">
      <div id="bams-colleges" />
      <div className="container mx-auto px-4">

        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="text-section font-bold text-gray-900 font-heading" style={{textWrap: 'balance'}}>
            College Information Hub
          </h2>
          <p className="mt-4 text-gray-600 text-lg">
            Explore detailed information about medical and ayurvedic colleges across India and Nepal.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabChange(tab.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-150 ${
                activeTab === tab.id
                  ? 'bg-primary-800 text-white shadow-sm'
                  : 'bg-white text-gray-700 border border-slate-200 hover:border-primary-300 hover:text-primary-800'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Table container */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 md:p-8">
          <h3 className="text-lg md:text-xl font-semibold text-gray-900 font-heading text-center mb-6">
            {tableInfo.title}
          </h3>

          {/* Filters */}
          {(tableInfo.locations?.length > 0 || tableInfo.hasFees || tableInfo.hasSeats) && (
            <div className="flex flex-col md:flex-row items-start md:items-end gap-4 flex-wrap mb-6 pb-6 border-b border-slate-100">
              {tableInfo.locations?.length > 0 && (
                <div>
                  <label htmlFor="location-filter" className="block text-xs font-medium text-gray-600 mb-1">Filter by Location</label>
                  <select id="location-filter" value={locationFilter} onChange={(e) => setLocationFilter(e.target.value)} className={selectClass}>
                    <option value="">All Locations</option>
                    {tableInfo.locations.map((loc) => (
                      <option key={loc} value={loc}>{loc}</option>
                    ))}
                  </select>
                </div>
              )}

              {tableInfo.hasFees && tableInfo.feeRanges.length > 0 && (
                <div>
                  <label htmlFor="fee-filter" className="block text-xs font-medium text-gray-600 mb-1">Filter by Fees</label>
                  <select id="fee-filter" value={feeFilter} onChange={(e) => setFeeFilter(e.target.value)} className={selectClass}>
                    <option value="">All Fee Ranges</option>
                    {tableInfo.feeRanges.map((range) => (
                      <option key={range.value} value={range.value}>{range.label}</option>
                    ))}
                  </select>
                </div>
              )}

              {tableInfo.hasSeats && tableInfo.seatRanges.length > 0 && (
                <div>
                  <label htmlFor="seats-filter" className="block text-xs font-medium text-gray-600 mb-1">Filter by Seats</label>
                  <select id="seats-filter" value={seatsFilter} onChange={(e) => setSeatsFilter(e.target.value)} className={selectClass}>
                    <option value="">All Seat Ranges</option>
                    {tableInfo.seatRanges.map((range) => (
                      <option key={range.value} value={range.value}>{range.label}</option>
                    ))}
                  </select>
                </div>
              )}

              {(locationFilter || feeFilter || seatsFilter) && (
                <button
                  onClick={() => { setLocationFilter(''); setFeeFilter(''); setSeatsFilter(''); }}
                  className="text-sm text-primary-700 hover:text-primary-900 border border-primary-200 hover:border-primary-400 rounded-lg px-3 py-2 transition-colors duration-150"
                >
                  Clear Filters
                </button>
              )}
            </div>
          )}

          <DataTable
            data={tableInfo.data}
            columns={tableInfo.columns}
            title={tableInfo.title}
          />
        </div>
      </div>
    </section>
  );
};

export default CollegeInfoTabs;
